// Get Merchant By Id
export const GET_MERCHANT_BY_ID_REQUEST = 'GET_MERCHANT_BY_ID_REQUEST';
export const GET_MERCHANT_BY_ID_DONE = 'GET_MERCHANT_BY_ID_DONE';
export const GET_MERCHANT_BY_ID_FAILED = 'GET_MERCHANT_BY_ID_FAILED';

// Edit Merchant
export const EDIT_MERCHANT_REQUEST = 'EDIT_MERCHANT_REQUEST';
export const EDIT_MERCHANT_DONE = 'EDIT_MERCHANT_DONE';
export const EDIT_MERCHANT_FAILED = 'EDIT_MERCHANT_FAILED';